import { Grid } from "@mui/material";
import MxModalTemplate2 from "@rf-l1/modal/MxModalTemplate2";
import useModal from "@rf/base/modal/useModal";
import { useSeoFormActions } from "@rf/property/module/components/property-form/store/slices/SeoFormSlice";

type Direction = "es_to_en" | "en_to_es";

// Exposes a function to open the translate modal with capability flags
const useTranslateTitleDescription = () => {
  const { modal, onClose } = useModal();
  const { translateSection } = useSeoFormActions();

  const handleTranslateTitleDescription = (canEsToEn: boolean, canEnToEs: boolean) => {
    return modal({
      template: (
        <MxModalTemplate2>
          <Grid container spacing={2}>
            <Grid item xs={12} >
              <TranslateOptionCard
                enabled={canEsToEn}
                title="Traducir de español a inglés"
                description="Requiere título y descripción en español"
                onClick={() => {
                  translateSection("es_to_en");
                  onClose();
                }}
              />
            </Grid>
            <Grid item xs={12} >
              <TranslateOptionCard
                enabled={canEnToEs}
                title="Traducir de inglés a español"
                description="Requiere título y descripción en inglés"
                onClick={() => {
                  translateSection("en_to_es");
                  onClose();
                }}
              />
            </Grid>
          </Grid>
        </MxModalTemplate2>
      ),
      options: {
        title: 'Selecciona la dirección de la traducción',
        size: {
          xs: { width: "92%", height: "auto", maxHeight: "80vh" },
          md: { width: "640px", height: "auto", maxHeight: "80vh" },
          lg: { width: "500px", height: "auto", maxHeight: "80vh" },
        }
      }
    });
  };

  return { handleTranslateTitleDescription };
};

export default useTranslateTitleDescription;



import { Paper, useTheme } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";

interface TranslateOptionCardProps {
  title: string;
  description: string;
  enabled: boolean;
  onClick: () => void;
}

const TranslateOptionCard = ({ title, description, enabled, onClick }: TranslateOptionCardProps) => {
  const theme = useTheme();
  const handleClick = () => {
    if (!enabled) return;
    onClick();
  };

  return (
    <Paper
      onClick={handleClick}
      elevation={0}
      sx={{
        py: 3,
        px: 2,
        cursor: enabled ? "pointer" : "not-allowed",
        border: "1px solid",
        borderColor: "divider",
        background: enabled ? "transparent" : theme.palette.action.disabledBackground,
        borderRadius: 1
      }}
    >
      <MxTypography variant="subtitle2" color='primary.main'>{title}</MxTypography>
      <MxTypography variant="caption" color="text.secondary">
        {description}
      </MxTypography>
    </Paper>
  );
};
